import { CSSProperties } from "react";

const commonBox: CSSProperties = {
  width: 500,
  padding: 4,
  borderRadius: 2,
  backgroundColor: "#fff",
};

export const styles: { [key: string]: CSSProperties } = {
  container: {
    width: "100vw",
    height: "94vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
  },
  box: {
    ...commonBox,
  },
  isSubmittedBox: {
    textAlign: "center",
    ...commonBox,
  },
  backButton: {
    padding: 0,
  },
  input: {
    marginTop: 3,
  },
  button: {
    marginTop: 3,
  },
  moveButton: {
    backgroundColor: "#f2f2f2",
    color: "#555",
  },
};
